import { SnackbarProgrammatic as Snackbar } from 'buefy';

export default function messageInformationSnackBar(message, messageAction, action, color) {
  Snackbar.open({
    message: message,
    type: color || 'is-white',
    position: 'is-top',
    duration: 5000,
    actionText: messageAction,
    onAction: () => {
      action();
    },
  });
}
